const TimerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="14" r="8" stroke="#6c757d" fill="#f8f9fa" />
      <line x1="12" y1="14" x2="12" y2="10" stroke="#6c757d" />
      <line x1="9" y1="3" x2="15" y2="3" stroke="#6c757d" />
      <line x1="12" y1="6" x2="12" y2="3" stroke="#6c757d" />
    </svg>
  );
};

export default TimerIcon;
